/* eslint-disable @next/next/no-img-element */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useEffect, useState, useRef } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import {
  filterFileType,
  swalConfirm,
  swalError,
  swalSuccess,
} from "@unisearch/helpers";
import {
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import API from "@unisearch/helpers/api";
import styles from "./media.module.scss";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useRouter } from "next/router";
import { getAssets } from "@unisearch/helpers";

export const MediaUPload = ({
  onUploaded,
  showTitle = true,
  allowItem = "all",
  ...props
}) => {
  const btnRef = useRef();

  const formates = [
    "image/jpg",
    "image/jpeg",
    "image/png",
    "image/webp",
    "application/pdf",
    "application/xls",
    "application/xlsx",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/docx",
  ];

  const [allowFormate, setAllowFormate] = useState();

  const allowed_size = 1000000;
  const [loading, setLoading] = useState(false);
  const [names, setNames] = useState([]);
  const [altName, setAltName] = useState([]);
  const [tags, setTags] = useState([]);
  const [fileState, setFileState] = useState([]);

  const changeName = (e) => {
    let index = e.target.name.replace("file_name_", "");
    let namesArr = [...names];
    namesArr[index] = e.target.value;
    setNames(namesArr);
  };

  const changeAlt = (e) => {
    let index = e.target.name.replace("alt_name_", "");
    let altNameArr = [...altName];
    altNameArr[index] = e.target.value;
    setAltName(altNameArr);
  };

  //remove item which upload
  const removeCurrent = (index) => {
    let fileArr = [...fileState];
    let namesArr = [...names];
    let tagsArr = [...tags];
    let altNameArr = [...altName];
    if (index !== -1) {
      fileArr.splice(index, 1);
      namesArr.splice(index, 1);
      tagsArr.splice(index, 1);
      altNameArr.splice(index, 1);
      setFileState(fileArr);
      setNames(namesArr);
      setAltName(altNameArr);
      setTags(tagsArr);
    }
  };

  const handleRemove = (index) => {
    swalConfirm("to remove this")
      .then((result) => {
        if (result.isConfirmed) {
          removeCurrent(index);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const onFileChange = (event) => {
    let namesArr = [...names];
    let tagsArr = [...tags];
    let fileArr = [...fileState];
    let files = event.target.files;

    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        if (
          allowFormate.includes(files[i].type) &&
          files[i].size / 1000 <= allowed_size
        ) {
          let fname = files[i].name;
          let name = fname
            .split(".")
            .slice(0, -1)
            .join(".");
          namesArr.push(name);

          // let tagName = files[i].type.split("/")[0];
          let tagName = filterFileType(files[i].type);
          tagsArr.push(tagName);

          fileArr.push(files[i]);
        } else {
          swalError("Upload file ( " + files[i].name + " ) is not allowed");
        }
      }
      setFileState(fileArr);
      setNames(namesArr);
      setAltName(namesArr);
      setTags(tagsArr);

      document.getElementById("image").value = "";
    }
  };

  const createTable = () => {
    let table = [];
    if (fileState && fileState.length > 0) {
      for (let i = 0; i < fileState.length; i++) {
        if (allowFormate.indexOf(fileState[i].type) > -1) {
          table.push(
            <TableRow key={i}>
              <TableCell>{i + 1}</TableCell>
              <TableCell>
                <input
                  name={`file_name_${i}`}
                  key={i}
                  onChange={changeName}
                  value={names[i]}
                  className={styles.fileName}
                />
              </TableCell>
              <TableCell>
                <input
                  name={`alt_name_${i}`}
                  key={i}
                  onChange={changeAlt}
                  value={altName[i]}
                  className={styles.fileName}
                />
              </TableCell>
              <TableCell>
                <span className={styles.shorter}>
                  {filterFileType(fileState[i].type)}
                </span>
              </TableCell>
              <TableCell>
                <IconButton
                  color="warning"
                  onClick={() => handleRemove(i)}
                  value={i}
                >
                  <RiDeleteBin6Line />
                </IconButton>
              </TableCell>
            </TableRow>
          );
        } else {
          //remove state
          removeCurrent(i);
          //show alert
          swalError(fileState[i].type + " Not Allowed");
        }
      }
    }
    return table;
  };

  //upload file
  const saveFile = async (values) => {
    swalConfirm("To submit this file?", "Are you sure", "Yes upload it").then(
      async (res) => {
        if (res.isConfirmed) {
          setLoading(true);
          const formData = new FormData();
          formData.append("mediaName", names.toString());
          formData.append("alt", altName.toString());
          formData.append("tag", tags.toString());

          if (fileState.length > 0) {
            fileState.map((file, index) => {
              formData.append("files", file);
            });
          }

          await API.post("/media-manager", formData)
            .then((res) => {
              if (!res.error) {
                swalSuccess(res.message);
                setTimeout(() => {
                  if (onUploaded) onUploaded(true);
                }, 100);
              } else {
                swalError("Upload Failed");
              }
            })
            .catch((error) => {
              swalError(error);
            });
          setLoading(false);
        }
      }
    );
  };

  //set Allow formates
  useEffect(() => {
    if (allowItem == "all") {
      setAllowFormate(formates);
    } else if (allowItem == "image") {
      setAllowFormate(["image/jpg", "image/jpeg", "image/png", "image/webp"]);
    } else if (allowItem == "pdf") {
      setAllowFormate(["application/pdf"]);
    } else if (
      allowItem == "docx" ||
      allowItem == "doc" ||
      allowItem == "xlsx" ||
      allowItem == "xls"
    ) {
      setAllowFormate([
        "application/xls",
        "application/xlsx",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/docx",
      ]);
    }
  }, [allowItem]);

  return (
    <div className={styles.wrapper}>
      {showTitle && (
        <div className={styles.heading}>
          <h2>Media Upload</h2>
        </div>
      )}
      <div className={styles.content}>
        <Grid container spacing={4}>
          <Grid item md={3} sm={12}>
            <div className={styles.form_group}>
              <label htmlFor="image">
                <input
                  id="image"
                  type="file"
                  name="files"
                  multiple={true}
                  onChange={(e) => onFileChange(e)}
                  style={{ display: "none" }}
                  disabled={loading}
                />

                <div className={styles.media_upload_wrapper}>
                  <div className={styles.image_wrapper}>
                    <img
                      src={getAssets("assets/images/vector-image.png")}
                      alt="Vector"
                    />
                  </div>
                  <div className={styles.text1}>
                    Drop your Image here, or <span>browse</span> on your
                    computer
                  </div>
                  <div className={styles.text2}>
                    Support: jpg, jpeg, png, pdf
                  </div>
                </div>
              </label>

              {fileState && fileState.length > 0 ? (
                <button
                  ref={btnRef}
                  type="submit"
                  className={`btn btn-warning ${styles.action_btn}`}
                  onClick={() => saveFile()}
                  disabled={loading}
                >
                  {loading && <CircularProgress size={20} />}
                  <span className="apsis-loader">Upload Files</span>
                </button>
              ) : (
                <></>
              )}
            </div>
          </Grid>

          <Grid item md={9} sm={12}>
            <TableContainer>
              <Table className={`table ${styles.uploadTable}`}>
                <TableHead>
                  <TableRow>
                    <TableCell>SL</TableCell>
                    <TableCell>New Name</TableCell>
                    <TableCell>Alt Tag</TableCell>
                    <TableCell>Type</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>{createTable()}</TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default MediaUPload;
